import { render, staticRenderFns } from "./SideButtons.vue?vue&type=template&id=35b573d8&scoped=true&"
import script from "./SideButtons.vue?vue&type=script&lang=js&"
export * from "./SideButtons.vue?vue&type=script&lang=js&"
import style0 from "./SideButtons.vue?vue&type=style&index=0&id=35b573d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b573d8",
  null
  
)

export default component.exports